import { takeLatest, put } from 'redux-saga/effects';

import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';
import {
  actionSetGridDataInvalid,
  actionSetGridDataValid,
} from 'react-redux-app/lib/modules/grid/actions';

import { getLinkGridName } from '../../utils/linkGrid';

import {
  ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
  ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
  ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__FAIL,

  ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
  ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
  ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__FAIL,

  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL,

  ACTION_EDIT_SITE_FOOTER_LINK__REQUEST,
  ACTION_EDIT_SITE_FOOTER_LINK__SUCCESS,
  ACTION_EDIT_SITE_FOOTER_LINK__FAIL,

  ACTION_DELETE_SITE_FOOTER_LINK__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK__FAIL,
} from '../../actionTypes';


function* enableGrid(action) {
  try {
    const { linkId } = action.payload;

    yield put(actionSetGridDataValid(getLinkGridName(linkId)));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

function* disableGrid(action) {
  try {
    const { linkId } = action.payload;

    yield put(actionSetGridDataInvalid(getLinkGridName(linkId)));
  } catch (e) {
    yield put(actionAddException(e));
  }
}

export default function* saga() {
  yield takeLatest([
    ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
    ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
    ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
    ACTION_EDIT_SITE_FOOTER_LINK__REQUEST,
    ACTION_DELETE_SITE_FOOTER_LINK__REQUEST,
  ], disableGrid);

  yield takeLatest([
    ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
    ACTION_CREATE_SITE_FOOTER_LINK_TRANSLATION__FAIL,
    ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
    ACTION_EDIT_SITE_FOOTER_LINK_TRANSLATION__FAIL,
    ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
    ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL,
    ACTION_EDIT_SITE_FOOTER_LINK__SUCCESS,
    ACTION_EDIT_SITE_FOOTER_LINK__FAIL,
    ACTION_DELETE_SITE_FOOTER_LINK__SUCCESS,
    ACTION_DELETE_SITE_FOOTER_LINK__FAIL,
  ], enableGrid);
}
